/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-05-27 11:16
 * @LastEditors: 许 文强 wenqiang.xu@ginlong.com
 * @LastEditTime: 2026-02-10 15:52:49
 * @FilePath: \glyun_web_Vue3\src\utils\axios\index.js
 * @Description: 请求方式封装
 */
import axios from './request.js'
import { getLang } from '@/utils/changeSystem/index.js'
import { getDictionaryLanguageCode } from '@/utils/businessDict.js'
import { contentMd5, getAuthorization, getHeadersDelayTime } from './sdk'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'

// console.log("🚀 ~ axios:", axios)
export function post(url = '', data = {}, config = {}) {
  return request(url, data, { ...config, method: 'POST' })
}
export function get(url = '', data = {}, config = {}) {
  return request(url, data, { ...config, method: 'GET' })
}

// code非0, 不需要msg提示的接口调用
const noMessageUrlArr = ['/user/vQrcodeLogin', '/inverter/devControl', '/inverter/detail', '/oauth/third/login', '/inverter/readTemplateValues', '/inverter/writeTemplateValues', '/dnsp/matchDnsp', '/captcha/get', '/captcha/check']
// code非0, 不需要msg提示的code码
const noMessageCodeArr = ['B0049', 'B0054', 'B0053', '3', '4', '5', 'B0212', 'M0010', '401','B0791','B0820']

function request(url, data, config) {
  for(let index in data){  //删除data对象中的空字符串和null的   键值对
    if((typeof data[index]) === 'string' && data[index] !== ""){
      data[index] = data[index].trim()
    }
    if(data[index] === "" || data[index] === null){
      delete data[index]
    }
  }
  data.localTime = Date.now()
  data.localTimeZone = dayjs().utcOffset() / 60
  data.language = getLang()
  return new Promise((resolve, reject) => {
    let axiosConfig = {
      baseURL: getBaseURL(url),
      method: config?.method,
      url: url,
      headers: getHeaders(url, data, config),
      retryTimes: 3,
    }
    if (config.responseType) axiosConfig.responseType = config.responseType
    if (config?.method === 'POST') {
      axiosConfig.data = data
    } else if (config?.method === 'GET') {
      axiosConfig.params = data
      axiosConfig.xhrFields = {
        withCredentials: true,
      }
    }
    axios(axiosConfig).then(
      (response) => {
        // console.log("🚀 ~ post ~ response:", response)
        if (response) {
          if (config.responseType) {
            resolve(response)
          } else {
            if(
              !isResponseSuccess(response.data, config.successCodes)
              && !noMessageCodeArr.includes(response.data?.code)
              && !noMessageUrlArr.find(item => axiosConfig.url.includes(item))
              && response.data?.msg
            ){
              ElMessage.error(response.data.msg || response.msg)
            }
            resolve(response.data)
          }
        }
      },
      (err) => {
        if (err === 'ERR_CANCELED') return
        reject(err)
      },
    )
  })
}

function isResponseSuccess(data, successCodes = ['0', '200']) {
  if (data?.success === false) return false
  if (data?.code !== undefined && data?.code !== null) {
    return successCodes.map(String).includes(String(data.code))
  }
  return data?.success === true
}

function getBaseURL(url) {
  let baseURL = axios.defaults.baseURL
  let reg = /^\/big\/data/ // 大数据接口地址
  let reg2 = /^\/ag\/getCsInfo/ //
  let reg3 = /^\/oauth\/third/
  let reg4 = /^\/oauth\/sso/
  let reg5 = /^\/dictionary-api/
  if (reg.test(url)) {
    baseURL = import.meta.env.VITE_API_BASE_URL_BIG_DATA
  } else if (reg2.test(url)) {
    baseURL = import.meta.env.VITE_API_BASE_URL_AG_GET_CS_INFO
  } else if (reg3.test(url) || reg4.test(url)) {
    // 开发环境走 Vite 代理，生产环境直接请求
    baseURL = import.meta.env.DEV ? '' : import.meta.env.VITE_API_BASE_URL_THIRD
  } else if (reg5.test(url)) {
    // 开发环境走 Vite 代理，生产环境直接请求
    baseURL = import.meta.env.VITE_I18N_API_BASE
  }
  return baseURL
}
function getHeaders(url, data, { contentType = 'application/json', method, oAuthToken }) {
  // 数据MD5
  const contentMd5Result = contentMd5(JSON.stringify(data))
  // 时间
  const date = getHeadersDelayTime()
  let baseConfig = {
    'Content-MD5': contentMd5Result,
    Authorization: getAuthorization({ contentMd5Result, date, url, method }),
    Time: date,
    'Content-Type': contentType + ';charset=UTF-8',
    language: getLang(),
    'Device-Id': getDeviceId(),
    Version: import.meta.env.VITE_VERSION,
    platform: 'Web',
  };
  if (/^\/dictionary-api\//.test(url)) {
    baseConfig['accept-language'] = getDictionaryLanguageCode(getLang())
  }
  //oAuthToken 第三方登陆
  console.log('oAuthToken',url,axios.defaults.baseURL)
  return oAuthToken ? {...baseConfig,'x-oauth-token':oAuthToken} : baseConfig;
}
function getDeviceId() {
  // 随机设备id
  let deviceId = localStorage.getItem('headerDeviceId') || random(false, 64)
  localStorage.setItem('headerDeviceId', deviceId)
  return deviceId
}
function random(randomFlag, max) {
  let str = '',
    arr = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ]
  for (let i = 0; i < max; i++) {
    let pos = Math.round(Math.random() * (arr.length - 1))
    str += arr[pos]
  }
  return str
}
